import { PRINTED_NAME_MAX_LENGTH } from '../constants';

export const formatAcknowledgmentTimestamp = (dateString: string): string => {
  const cleanedDate = dateString
    .replace(/\.,/g, '.')
    .replace(/,/g, '')
    .replace(/\.\+/g, '+')
    .replace(/\.-/g, '-');
  const date = new Date(cleanedDate);

  if (isNaN(date.getTime())) {
    console.error('Failed to parse date:', dateString);
    return 'Invalid date';
  }

  const month = date.toLocaleString('en-US', { month: 'short' });
  const day = date.getDate();
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours || 12;

  return `${month} ${day}, ${year} at ${hours}:${minutes} ${ampm}`;
};

export const getCurrentTimestamp = (): string => {
  return new Date().toISOString();
};

export const validatePrintedName = (name: string): boolean => {
  const trimmed = name.trim();
  return trimmed.length > 0 && trimmed.length <= PRINTED_NAME_MAX_LENGTH;
};
